import { InstanceResponseModel } from '../../../../../apis/v1/instances/model';
import DangerZoneCard from './DangerZoneCard';
import GeneralSettingsCard from './GeneralSettingsCard';
import ResizeInstanceCard from './ResizeInstanceCard';

interface SettingsTabPanelProps {
    instance: InstanceResponseModel;
}

export default function SettingsTabPanel({ instance }: SettingsTabPanelProps) {
    return (
        <div className="w-full flex flex-col gap-4">
            <GeneralSettingsCard instance={instance} />
            <ResizeInstanceCard instance={instance} />
            <DangerZoneCard instanceId={instance.id} hostname={instance.hostname} />
        </div>
    );
}
